<ul id="version" class="d-flex flex-wrap flex-row gap-1 container-fluid mt-3">
  <li>
    <span class="me-1">Stand:</span>
    <span>Datum {{ kursnetDatenstandDatum }} |</span>
  </li>
  <li>
    <span class="me-1">Version:</span>
    <span>{{ versionCommit }}</span>
  </li>
</ul>
